// usePcPointer — PC 系の入力 (マウス / トラックパッド) か判定する hook。
// `(hover: hover) and (pointer: fine)` が真のとき PC (タッチ主体端末は偽)。
// matchMedia が無い環境 (SSR / テスト) は false。変化 (2-in-1 のモード切替等) に追従する。

import { useEffect, useState } from 'react';

export const PC_POINTER_MEDIA_QUERY = '(hover: hover) and (pointer: fine)';

const read = (): boolean =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia(PC_POINTER_MEDIA_QUERY).matches;

export const usePcPointer = (): boolean => {
  const [isPc, setIsPc] = useState<boolean>(read);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(PC_POINTER_MEDIA_QUERY);
    const update = (): void => setIsPc(mql.matches);
    update();
    mql.addEventListener('change', update);
    return () => mql.removeEventListener('change', update);
  }, []);
  return isPc;
};
